import { IUnreadListRequest, EUnreadListActionTypes } from './types';
import { TChatDataInListSchema } from '../../types/chatList';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Запрос за списком непрочитанных чатов
 */
export const setUnreadListPending = actionGenerator<EUnreadListActionTypes.SetPending, IUnreadListRequest>(
  EUnreadListActionTypes.SetPending,
);

/**
 * Установить список непрочитанных чатов
 */
export const setUnreadListSucceed = actionGenerator<EUnreadListActionTypes.SetSucceed, TChatDataInListSchema[]>(
  EUnreadListActionTypes.SetSucceed,
);

/**
 * Установить ошибку запроса списка непрочитанных чатов
 */
export const setUnreadListFailed = actionGenerator<EUnreadListActionTypes.SetFailed, void>(
  EUnreadListActionTypes.SetFailed,
);
